export default __webpack_public_path__ + "static/media/planet-gb9c977396_1280.abad9eb1.jpg";